import React from 'react';

const Footer = () => {
    return (
        <footer>
            <h3>&#169; Chris Bolas: Made for The Odin Project</h3>
        </footer>
    );
}

export default Footer;
